var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0166821 10.275H0L3.6645 2.06738L6.0278 3.12392L2.3633 11.3259H2.34662L0.0889712 13.2499L0.0166821 10.275Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21665 0.310253L6.29542 0.794034C6.65131 0.949734 6.80701 1.36679 6.65131 1.72267L6.19533 2.74028L3.83203 1.68375L4.28801 0.666138C4.44371 0.310253 4.86076 0.154553 5.21665 0.310253V0.310253Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ef20ed66808465551fbd9c3eb4b19cc8.svg";
export { ForwardRef as ReactComponent };